import { Skeleton } from '@xtm-group/ui';

/**
 * Full-viewport, centered loading placeholder used for route-level Suspense and
 * the auth / active-workflow gates. Single source of truth so every full-page
 * loading state stays visually consistent.
 */
export function PageLoader() {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-3">
      <Skeleton className="h-8 w-8 rounded-full" />
      <Skeleton className="h-4 w-24" />
    </div>
  );
}
